import { HttpClient } from '@angular/common/http'
import { inject, Injectable } from '@angular/core'
import { environment } from '@monorepo-channels/shared/util-environments'
import { Observable } from 'rxjs'
import { Voucher } from './voucher.component'

@Injectable()
export class VoucherService {
	private http = inject(HttpClient)
	private baseURL = `${environment.channelsAPIURL}/api`

	validateVoucher(code: string): Observable<Voucher> {
		return this.http.get<Voucher>(`${this.baseURL}/v1/vouchers/bb/${code}`)
	}
}
